import usePrivateAxios from '@/common/api/usePrivateAxios'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { useMutation } from '@tanstack/react-query'
import { CompanyContractType } from '@/features/privateCompanies/types/companyContract.type'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { transformNewGeos } from '@/common/utils/geoTransformers'
import { UpdateContractGeneralInformationSchema } from '../../schemas/contract/updateContractGeneralInformation.schema'

interface UseUpdateContractGeneralInformationProps {
  contractId?: string
  contract?: CompanyContractType
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractGeneralInformation = ({ contractId, contract, onSuccess, onError }: UseUpdateContractGeneralInformationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractBillDetails'],
    mutationFn: async (data: UpdateContractGeneralInformationSchema) => {
      const payload = {
        contract: {
          in_effect_until: data?.contract?.in_effect_until,
          geo_geoables_attributes: getRailsUpdate(
            contract?.geo_geoables || [],
            data?.contract?.geo_geoables || [],
            (geo) => geo.geo.id,
            (geo) => geo.value || '',
            mapToDeletion,
            transformNewGeos,
          ),
        }
      }

      delete data.contract.geo_geoables;

      await privateAxios.put(`/client/contracts/${contractId}/update_contract_general_information`, payload);
    },
    onSuccess,
    onError,
  })
}
